import {
    GET_CREW_LIST_REQUEST, GET_CREW_LIST, CREW_SUCCESS, CREW_FAILURE,
    CREW_CLEAR, GET_WORK_PLAN, GET_CREW_INFO, CLEAR_CREW_LIST,
    WHATIF_INFO, WHATIF_CALCULATE, UPDATE_CREW_ACTIVE, GET_SELECTED_CREW
} from '../constants/action-types';

const initialState = {
    isRequesting: false,
    crewList: [],
    selectedCrew: null,
    crewInfo: {},
    workPlanInfo: {
        total_working_days: 0,
        acres_per_day: 0,
        acres_per_hour: 0,
        equipment_group_list: []
    },
    whatIfInfo: {},
    whatIfPlan: {
        total_working_days: 0,
        acres_per_day: 0,
        acres_per_hour: 0,
        end_date: null
    },
    save: {
        isSuccess: true,
        message: ''
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CREW_LIST_REQUEST:
            state = { ...state, isRequesting: true, crewList: initialState.crewList };
            break;
        case GET_CREW_LIST:
            state = { ...state, isRequesting: false, crewList: action.payload ? action.payload : initialState.crewList };
            break;
        case GET_SELECTED_CREW:
            state = { ...state, selectedCrew: action.payload ? action.payload : initialState.selectedCrew };
            break;
        case GET_CREW_INFO:
            state = { ...state, crewInfo: action.payload ? action.payload : initialState.crewInfo };
            break;
        case CREW_SUCCESS:
            state = { ...state, save: initialState.save };
            break;
        case CREW_FAILURE:
            state = { ...state, save: { isSuccess: false, message: action.payload.message } };
            break;
        case CREW_CLEAR:
            state = { ...state, save: initialState.save };
            break;
        case GET_WORK_PLAN:
            state = { ...state, workPlanInfo: action.payload ? action.payload : initialState.workPlanInfo };
            break;
        case CLEAR_CREW_LIST:
            state = { ...state, crewList: initialState.crewList };
            break;
        case WHATIF_INFO:
            state = { ...state, whatIfInfo: action.payload ? action.payload : initialState.whatIfInfo };
            break;
        case WHATIF_CALCULATE:
            state = { ...state, whatIfPlan: action.payload ? action.payload : initialState.whatIfPlan };
            break;
        case UPDATE_CREW_ACTIVE:
            const crewList = [...state.crewList];
            crewList.forEach(item => { if (item.crew_uuid === action.payload.crew_uuid) item.active = action.payload.active; });
            state = { ...state, crewList };
            break;
        default:
            break;
    }
    return state;
}